import { render } from "./BatchMaster.vue?vue&type=template&id=d9a5b302&scoped=true"
import script from "./BatchMaster.vue?vue&type=script&lang=js"
export * from "./BatchMaster.vue?vue&type=script&lang=js"

import "./BatchMaster.vue?vue&type=style&index=0&id=d9a5b302&scoped=true&lang=scss"

import exportComponent from "C:\\prathamesh\\mahajyoti_admin_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9a5b302"]])

export default __exports__